// api/attendanceApi.js
import axios from "axios";

const BASE_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/attendance`,
});

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// ── Mark Single Attendance ────────────────────────────────────────────────
// POST /api/attendance/mark
// payload: { staffId, date, status, checkIn, checkOut, leaveType, notes }
export async function markAttendance(payload) {
  try {
    const res = await BASE_URL.post(`/mark`, payload, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Bulk Mark Attendance (whole team in one call) ─────────────────────────
// POST /api/attendance/bulk-mark
// payload: { date, records: [{ staffId, status, checkIn, checkOut, leaveType, notes }] }
export async function bulkMarkAttendance(payload) {
  try {
    const res = await BASE_URL.post(`/bulk-mark`, payload, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Get Staff Monthly Attendance ──────────────────────────────────────────
// GET /api/attendance/staff/:staffId?month=2025-07
export async function getStaffAttendance(staffId, month) {
  try {
    const res = await BASE_URL.get(`/staff/${staffId}`, {
      ...getHeaders(),
      params: { month },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Get Daily Attendance (team view) ─────────────────────────────────────
// GET /api/attendance/today?orgId=&zoneId=&date=&n_page=&n_limit=
export async function getDailyAttendance(payload) {
  try {
    const {
      orgId = "", zoneId = "",
      date = "", n_page = 1, n_limit = 50,
    } = payload || {};
    const res = await BASE_URL.get(`/today`, {
      ...getHeaders(),
      params: { orgId, zoneId, date, n_page, n_limit },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Get Monthly Attendance Grid (all staff × all days) ────────────────────
// GET /api/attendance/monthly-grid?month=2025-07&orgId=&zoneId=
export async function getMonthlyGrid(payload) {
  try {
    const { month = "", orgId = "", zoneId = "" } = payload || {};
    const res = await BASE_URL.get(`/monthly-grid`, {
      ...getHeaders(),
      params: { month, orgId, zoneId },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Get Monthly Report (all staff) ────────────────────────────────────────
// GET /api/attendance/monthly-report?month=2025-07&orgId=&zoneId=
export async function getMonthlyReport(payload) {
  try {
    const { month = "", orgId = "", zoneId = "" } = payload || {};
    const res = await BASE_URL.get(`/monthly-report`, {
      ...getHeaders(),
      params: { month, orgId, zoneId },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ── Delete Attendance Record (SUPERADMIN only) ────────────────────────────
export async function deleteAttendance(id) {
  try {
    const res = await BASE_URL.delete(`/${id}`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}